import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

export const authGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  const oidcSecurityService = inject(OidcSecurityService);
  const _router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        // Store the attempted URL for redirecting after login
        const targetUrl = state.url;
        console.log('Storing redirect URL:', targetUrl);
        sessionStorage.setItem('redirectUrl', targetUrl);
        
        // Trigger login
        oidcSecurityService.authorize();
        return false;
      }

      return true;
    })
  );
};